import type { JobResponse } from '@taxassist/api-client';
import { groupJobsByUserFriendlyStatus as baseGroupJobsByUserFriendlyStatus, type UserFriendlyStatus } from './statusMapping';

/**
 * Groups jobs by their user-friendly status for Kanban display with sorting
 * Uses the consolidated mapping logic from statusMapping
 */
export function groupJobsByUserFriendlyStatus(jobs: JobResponse[]): Record<UserFriendlyStatus, JobResponse[]> {
  const grouped = baseGroupJobsByUserFriendlyStatus(jobs);

  // Sort jobs within each status by last updated date (most recent first)
  Object.keys(grouped).forEach((status) => {
    grouped[status as UserFriendlyStatus].sort((a, b) => 
      new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    );
  });

  return grouped;
}